module.exports = __webpack_public_path__ + "img/1.84e5ccec.jpg";